/** Observe the canvas, including mobile browser chrome changes, without frame-loop layout reads. */
export function observeGameViewport(
  canvas: HTMLCanvasElement,
  onResize: (width: number, height: number) => void,
): () => void {
  let width = 0;
  let height = 0;
  let frame: number | undefined;
  const measure = (): void => {
    frame = undefined;
    const nextWidth = Math.max(1, canvas.clientWidth);
    const nextHeight = Math.max(1, canvas.clientHeight);
    if (width === nextWidth && height === nextHeight) return;
    width = nextWidth;
    height = nextHeight;
    onResize(width, height);
  };
  const schedule = (): void => {
    frame ??= window.requestAnimationFrame(measure);
  };
  const observer = new ResizeObserver(schedule);
  observer.observe(canvas);
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("orientationchange", schedule, { passive: true });
  window.screen.orientation?.addEventListener("change", schedule);
  window.visualViewport?.addEventListener("resize", schedule, { passive: true });
  measure();
  return () => {
    observer.disconnect();
    if (frame !== undefined) window.cancelAnimationFrame(frame);
    window.removeEventListener("resize", schedule);
    window.removeEventListener("orientationchange", schedule);
    window.screen.orientation?.removeEventListener("change", schedule);
    window.visualViewport?.removeEventListener("resize", schedule);
  };
}
